<template>
    <div class="toastContainer">
      <p class="toastText">{{text}} </p>
      <a class="toastBtn" @click="callInputMethodAndClose">{{actionName}}</a>
      <a class="toastBtn" @click="closeToast">{{closeText}}</a>
      </div>
  </template>
  
  <script>
  export default {
    name: "ToastComponent",
    props: {
    text: String,
    action: Function,
    actionName: String,
    closeText: String,
    },
    computed: {
      
    },
    methods: {
      closeToast() {
        this.$emit('close-toast');
      },
      callInputMethodAndClose() {
        this.action();
        this.closeToast();
      }
    }
  };
  </script>
  
  <style scoped>
    .toastContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: white;
      padding: 10px;
      background-color: #353535;
    }
    .toastBtn {
      margin: 5px;
      color: #a1c2fa !important;
      cursor: pointer;
      text-decoration: underline;
      text-transform: uppercase;
      font-size: 12px;
    }
    .toastText {
    font-size: 15px;
    flex-grow: 2;
  }
  @media only screen and (max-width: 600px) {
  
    .toastText {
    font-size: 12px;
  }
  .toastBtn {
      font-size: 10px;
    }
}

    

  </style>
  